module.exports = __webpack_public_path__ + "img/39_19.a14d3cdf.png";